import type { BadgeVariants } from '@forgd/ui-kit/badge'

export type IntegrationLevel = 'full' | 'partial' | 'none'

export function getIntegrationLevel(score: number): IntegrationLevel {
  if (score === 10) {
    return 'full'
  }

  if (score > 5) {
    return 'partial'
  }

  return 'none'
}

/**
 * An unknown integration status counts as fully integrated: data is only
 * treated as limited once a non-`full` status is known.
 */
export function isNotFullyIntegrated(status: IntegrationLevel | null | undefined): boolean {
  if (status == null) {
    return false
  }

  return status !== 'full'
}

const integrationLevelToColor: Record<IntegrationLevel, NonNullable<BadgeVariants['variant']>> = {
  full: 'green',
  partial: 'yellow',
  none: 'red',
}

export function getIntegrationBadge(level: IntegrationLevel) {
  const badgeColor = integrationLevelToColor[level]
  switch (level) {
    case 'full':
      return { label: 'Fully Integrated', shortLabel: 'Full', color: badgeColor }
    case 'partial':
      return { label: 'Partially Integrated', shortLabel: 'Partial', color: badgeColor }
    case 'none':
      return { label: 'Not Integrated', shortLabel: 'None', color: badgeColor }
  }
}
